@if (instances.length > 1) {
    <ws-ace-dropdown
        class="d-inline"
        position="end"
        [content]="selectedInstance.name">
        @for (instance of instances; track instance) {
            <button type="button" class="option"
                    [class.disabled]="instance.inactive"
                    (click)="instanceChanged(instance)">
                <span class="content">{{ instance.name }}</span>
            </button>
        }
    </ws-ace-dropdown>
}
